import * as actionTypes from "./actionTypes";
import * as commonActionTypes from "../../shared/commonActionTypes";

const initialState = {
  milestones: null,
  loading: false,
  forbidden: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUMMARY_MILESTONES_REQUEST:
      return { ...initialState, loading: true };

    case actionTypes.SUMMARY_MILESTONES_FAILURE:
      return {
        ...initialState,
        milestones: [],
        error: action.error,
        forbidden: action.forbidden
      };

    case actionTypes.SUMMARY_MILESTONES_SUCCESS:
      return {
        ...initialState,
        milestones: action.response
      };
    case commonActionTypes.CLEAR_CASE_SUMMARY_DATA:
    case commonActionTypes.LOGOUT:
    case commonActionTypes.SET_CONTEXT:
    case commonActionTypes.SET_MATTER:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
